<div class="mega_body-content">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="mega_header-information__sub-header">Confirmation</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="line-break"></div>
  </div>

  <ng-container *ngIf="!displayStatusPollingPopup">
    <div class="col-12 col-sm-12 col-md-7 col-lg-7 mega-trade-form-info">
      <div class="line-break-container">
        <ul class="list-inline upload-process-statuses-list">
          <li class="validated-text status-count" *ngIf="allocatedCount > 0">
            Allocated: {{ allocatedCount }}
          </li>
          <li class="validated-text status-count" *ngIf="allocatedCount === 0">
            Allocated: {{ allocatedCount }}
          </li>
          <li class="success-text link" (click)="scrollToReject()" *ngIf="rejectedCount > 0">
            <span class="show-pipe-symbol margin-pipe">|</span> Rejected: {{ rejectedCount }}
          </li>
          <li class="errors-text link" (click)="scrollToError()" *ngIf="errorCount > 0">
            <span class="show-pipe-symbol margin-pipe">|</span> Errors: {{ errorCount }}
          </li>
          <li class="success-text" *ngIf="rejectedCount === 0">
            <span class="show-pipe-symbol margin-pipe">|</span> Rejected: {{ rejectedCount }}
          </li>
          <li class="errors-text" *ngIf="errorCount === 0">
            <span class="show-pipe-symbol margin-pipe">|</span> Errors: {{ errorCount }}
          </li>
        </ul>
      </div>

      <ng-container *ngIf="allocatedCount !== 0">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--allocate table-border">
            <p class="mega-status-title">Allocated</p>
            <span class="badge badge-allocated">{{ allocatedCount }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--allocate">
            <div class="row table-border">
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl data-left-align">
                <p>POOL #</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl data-left-align">
                <p>SETTLEMENT</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl data-right-align">
                <p>ISSUE AMOUNT</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl data-right-align">
                <p>FEE AMOUNT</p>
              </div>
            </div>
            <div
              class="row error-class table-border"
              *ngFor="let allocatedMega of commitResponse.allocatedMegas; trackBy: trackByIdentity"
            >
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 data-left-align">
                <p>{{ allocatedMega.megaNumber }}</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 data-left-align">
                <p>{{ allocatedMega.settlementDate | date: 'MM/dd/yyyy' }}</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 data-right-align">
                <p>{{ allocatedMega.issueAmount | currency: 'USD' : 'symbol' : '1.0' }}</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 data-right-align">
                <ng-container *ngIf="needsDisclaimer(allocatedMega); else noDisclaimer">
                  <p class="fee-warning-red">
                    {{ allocatedMega.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                  </p>
                </ng-container>
                <ng-template #noDisclaimer>
                  <p>{{ allocatedMega.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}</p>
                </ng-template>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--allocate">
                <p class="fee-warning-red">{{ disclaimerMessage }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="commitResponse.rejectedMegas !== null && rejectedCount !== 0">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--reject table-border">
            <p class="mega-status-title">Rejected</p>
            <span class="badge badge-error">{{ rejectedCount }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--reject">
            <div class="row table-border">
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl">
                <p>POOL #</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
            </div>
            <div
              class="row table-border error-class"
              *ngFor="let rejectedMega of commitResponse.rejectedMegas; trackBy: trackByIdentity"
            >
              <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                <p>{{ rejectedMega.megaNumber }}</p>
              </div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
              <div class="col-12 col-sm-12 col-md-3 col-lg-3"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="commitResponse.failedMegas !== null && errorCount !== 0">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--error table-border">
            <span class="mega-status-title">Errors</span>
            <span class="badge badge-error margin-left--fix--error-counter-badge">
              {{ errorCount }}</span
            >

            <div class="link-report full-error-report">
              <span (click)="downloadFullErrorReport()">Download full report</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 margin-left--fix--error">
            <div class="row table-border">
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl">
                <p>POOL #</p>
              </div>
              <div class="col-12 col-sm-12 col-md-9 col-lg-9 pl">
                <p>ERROR</p>
              </div>
            </div>
            <div
              class="row error-class table-border"
              *ngFor="let failedMega of commitResponse.failedMegas; trackBy: trackByIdentity"
            >
              <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                <p>{{ failedMega.megaNumber }}</p>
              </div>
              <div class="col-12 col-sm-12 col-md-9 col-lg-9">
                <p *ngIf="failedMega.errorType !== 'System Error'">{{ failedMega.errorType }}</p>
                <p *ngIf="failedMega.errorType === 'System Error'">
                  {{ failedMega.allocationStatusDescription }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showUnforeseenLegend">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 unforeseen-error">
            <p>
              <i class="fa fa-asterisk legend-icon"></i> For assistance with this error, please
              contact the Clearance/Settlement Group at
              <span class="link"
                ><a href="mailto:sto_megas@fanniemae.com">sto_megas&#64;fanniemae.com </a></span
              >
              or call 202-752-4800.
            </p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-12 col-sm-12 col-md-5 col-lg-5">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-2 col-lg-2"></div>
        <div class="col-12 col-sm-12 col-md-10 col-lg-10">
          <div class="mega-message-block">
            <p class="dealer-details">Dealer: {{ commitResponse.dealerName }}</p>
            <p class="dealer-details">Dealer Contact: {{ commitResponse.traderName }}</p>
            <p class="dealer-details">
              Committed Date: {{ commitResponse.uploadDate | date: 'MM/dd/yyyy' }}
            </p>
            <br />
            <p class="dealer-details">Transaction ID:</p>
            <p class="dealer-details">{{ commitResponse.jobReferenceUuid }}</p>
            <br />
            <p>
              Please review this summary of the results of your pool information upload. An email
              with this information and any applicable error reports has been sent to
              {{ commitResponse.traderEmail }}.
            </p>
            <br />
            <p>
              If you need to make changes prior to settlement, please contact the Fannie Mae
              Clearance/Settlement Group at
              <span class="link"
                ><a href="mailto:sto_megas@fanniemae.com">sto_megas&#64;fanniemae.com</a></span
              >.
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="displayStatusPollingPopup">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-2 col-lg-2 mask-field-allocate-title"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 mask-field-allocate"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 mask-field-allocate"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 mask-field-allocate"></div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-2 col-lg-2 mask-field-reject-title"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 mask-field-reject"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 mask-field-reject"></div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 mask-field-reject"></div>
        </div>
      </div>
    </div>

    <div class="confirmation-page-model-window">
      <div class="panel panel-default fadeInUpBig">
        <div class="panel-body pool-info-cancel-confirmation-model">
          <div>
            <i
              class="fa fa-spinner fa-spin fa-3x fa-fw icons-for-validating-status spinner-for-validating-status"
            ></i>
          </div>
          <h4 class="poll-message-header">We are processing your pools</h4>
          <span>This may take a few minutes.</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>
